var React = require('react');

function ArrowRight (props) {
    return React.createElement("svg",props,React.createElement("polygon",{"points":"56.02 0 54.89 1.13 60.94 7.2 0 7.2 0 8.8 60.94 8.8 54.89 14.87 56.02 16 64 8 56.02 0","fillRule":"evenodd"}));
}

ArrowRight.defaultProps = {"viewBox":"0 0 64 16"};

module.exports = ArrowRight;

ArrowRight.default = ArrowRight;
